<mat-grid-list cols="10" rowHeight="100px">

    <!-- Welcome Message -->
    <mat-grid-tile [colspan]="8">        
        <span *ngIf="this.userService.isAuthenticated()">        
            <span class="welcome_message">The user {{ this.userFirstName }} is correctly authenticated is symfonyID is {{ this.idSymfony }}</span>
        </span>
    </mat-grid-tile>
    <mat-grid-tile>
        <ul>
            <li *ngFor="let folder of this.Folders">{{folder.title}}</li>
        </ul>
    </mat-grid-tile>
</mat-grid-list>

